export enum SiteWalkStatusEnum {
    PUBLISHED = 'PUBLISHED',
    UNPUBLISHED = 'UNPUBLISHED',
}

export enum FloorPlanTypeEnum {
    IMAGE = 'IMAGE',
    VIDEO = 'VIDEO',
}

export enum FloorPlanStatusEnum {
    ENABLED = 'ENABLED',
    DISABLED = 'DISABLED',
}

export enum FileTypeGuiEnum {
    IMAGE = 'IMAGE',
    VIDEO = 'VIDEO',
    GIF = 'GIF',
    OTHER = 'OTHER',
}
